export default "__VITE_ASSET__BUymPbKQ__"